import {Observable} from 'rxjs';
import {DevicesProvider} from '../devices/device_provider';
import {ParticipantsProvider} from '../participants/participant_provider';
import {map, switchMap} from 'rxjs/operators';

export interface SystemStatus {
    ready: boolean;
}

export class SystemReadyProvider {
    constructor(
        private devicesProvider: DevicesProvider,
        private participantsProvider: ParticipantsProvider,
    ) {}

    public get(): Observable<SystemStatus> {
        // All participants who have a boatId should also have a deviceId
        return this.participantsProvider.get().pipe(
            switchMap((participantsTry) => {
                return this.devicesProvider.get().pipe(
                    map((devicesTry) => {
                        return participantsTry.flatMap((participants) => {
                            return devicesTry.map((devices) => {
                                return {
                                    ready: participants.every((participant) => {
                                        return (
                                            participant.boatId === null ||
                                            devices.some((device) => device.participantId === participant.id)
                                        );
                                    }),
                                };
                            });
                        });
                    }),
                );
            }),
            map((systemStatusTry) => {
                return systemStatusTry.getOrElse(() => ({ready: false}));
            }),
        );
    }
}
